export default "__VITE_ASSET__0digJrab__"